var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { SortBtn } from "../../../assets/svg/SortBtn";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var ButtonSort = function (props) {
    return (React.createElement(SvgButton, __assign({ name: IdStyles.ButtonSort, svg: SortBtn, onClick: props.onClick }, props)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonSort.tsx
// module id = 2610
// module chunks = 3